import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ReadyToScaleYourVision() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="19824" id="the-philanthropy-mission" className="bg-background bg-gradient-to-br from-accent/50 via-background to-background border-t border-border/40 py-20 md:py-32">
      <div ref={ref} className={`mx-auto max-w-7xl px-6 text-center transition-all duration-1000 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
        <h2 className="text-primary font-mono font-light tracking-wider !text-[58px]">Travel the World while Saving the World</h2>
        
        <p className="text-muted-foreground font-sans mx-auto mt-6 max-w-2xl text-lg md:text-xl tracking-tight">
          A lifetime of exploration and giving back. Join us in our mission to do well, and do good.
        </p>

        <div className="mt-10 flex justify-center">
          <Button asChild className="bg-transparent border border-primary text-foreground hover:bg-primary/5 hover:shadow-[0_0_20px_rgba(43,121,114,0.3)] h-auto rounded-sm px-10 py-4 text-lg font-mono uppercase tracking-widest transition-all duration-500 hover:scale-105">
            <Link to="/ImpactPage">
              LEARN ABOUT THE FUND
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}